<template>  
  <v-card>
    <v-toolbar flat>      
      <v-text-field flat dense filled
        v-model="term"
        append-icon="search"
        label="Search Tps"
        single-line
        hide-details        
        @input="search"
        style="max-width:200px"
      ></v-text-field>                 
      <v-spacer/>
      <v-btn fab color="green" dark small absolute right :to="{name:'master/tps/form'}"><v-icon>add</v-icon></v-btn>                      
    </v-toolbar>
    <v-card-text class="pa-0">      
      <v-container fluid grid-list-lg class="ma-0 pa-0">
        <v-layout row>
          <v-flex xs12 md12 style="position:relative">            
            <v-data-table dense 
              :headers="headers"
              :items="items"              
              :loading="loading"
              loading-text="Loading... Please wait"
              :items-per-page="-1"
              hide-default-footer  
              :options.sync="pagination" 
              must-sort                       
            > 
              <template v-slot:item.urut="{ item }">{{ ((page-1)*20)+(items.findIndex(x=>x==item)+1) }}</template>
              <template v-slot:item.alamat="{ item }">
                {{ item.alamat }} {{item.kelurahan.name}}, {{item.kecamatan.name}}, {{item.kabupaten.name}}, {{item.propinsi.name}} 
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon small color="blue" :to="{name:'master/tps/form',query:{id:item.id}}"><v-icon>edit</v-icon></v-btn>
              </template>              
            </v-data-table>
            <div class="text-center">
              <v-pagination
                v-model="page"
                :length="totalPages"
                circle
                :total-visible="9"
              ></v-pagination>
            </div>
          </v-flex>          
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card> 
</template>

<script>
import { debounce } from 'lodash'
import model from '@/app/models/master/Tps'

export default {
  data () {
    return {
      term : null,
      headers:[
        {text:'No', value:'urut'},
        {text:'No TPS', value:'no'},
        {text:'Name', value:'name'},
        {text:'PTL', value:'pt_l', align:'right'},
        {text:'PTP', value:'pt_p', align:'right'},
        {text:'Alamat', value:'alamat'},        
        {text:'#', value:'action'}
      ],
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,
      status: {1:'active',0:'inactive'},
    }
  },
  computed:{
    levels(){
      return this.$store.getters.DICTIONS.RegionLevel;      
    }
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    }
  },  
  created () {
    this.readItems()
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'id';                          
      
      const params = {
        perPage: 20,
        page: page,
        q: this.term,
        sort:sortby,
        expand:'kelurahan,kecamatan,kabupaten,propinsi'
      }

      model.index(params)
        .then(response => {
          this.items = response.data;
          this.totalPages = response.pagination.pageCount;               
          this.loading = false
        })
    },    
  },  
}
</script>